import _typeof from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.match";
import router from "../router";
var jsCallNative = window.jsCallNative || undefined;
var ua = navigator.userAgent.toLowerCase();
import wx from 'weixin-js-sdk';
import { param, filterUrl } from '@/utils/index';

//环境判断
export function isWX() {
  return ua.match(/MicroMessenger/i) == 'micromessenger' && ua.match(/miniProgram/i) != 'miniprogram';
}
export function isMP() {
  return ua.match(/MicroMessenger/i) == 'micromessenger' && ua.match(/miniProgram/i) == 'miniprogram';
}
export function isIOS() {
  return ua.indexOf('mac os') != -1 && window.webkit;
}
export function isAndroid() {
  return !!window.jsCallNative;
}
export function isApp() {
  return (isIOS() || isAndroid()) && !isWX() && !isMP();
}
export function openBaseUrl(url) {
  if (url.indexOf("http://") !== -1 || url.indexOf("https://") !== -1) {
    location.href = url;
  } else {
    router.push(url);
  }
}

//关闭小程序页面
export function closeMpPage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  wx.miniProgram.navigateBack(data);
}

// 原生返回
export function callNativeDismiss() {
  if (isAndroid()) {
    if (jsCallNative.callNativeDismiss) {
      jsCallNative.callNativeDismiss();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.callNativeDismiss) {
      window.webkit.messageHandlers.callNativeDismiss.postMessage('');
    }
  }
}

//统一关闭网页（兼容APP、小程序、微信浏览器）
export function closeWebPageUnity() {
  if (isApp()) {
    callNativeDismiss();
  } else if (isMP()) {
    closeMpPage();
  } else {
    router.back();
  }
}

//统一打开网页（兼容APP、小程序、微信浏览器）
export function openWebPageUnity(data) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var path;
  if (_typeof(data) === 'object') {
    path = data.path + '?' + param(data.query);
    if (data.title) {
      title = data.title;
    }
  } else {
    path = data;
  }
  if (isApp()) {
    openWebPage(path, title);
  } else if (isMP()) {
    openMpWebPage(path);
  } else {
    openBaseUrl(path);
  }
}

//打开小程序web页面
export function openMpWebPage(params) {
  if (location.href.indexOf('mpmark=eyemp') != -1) {
    wx.miniProgram.navigateTo({
      url: '/uniSubpackage/pages/web/pub?url=' + encodeURIComponent(params)
    });
  } else {
    wx.miniProgram.navigateTo({
      url: '/pages/web/pub?url=' + encodeURIComponent(params)
    });
  }
}

/**
 * 重载到小程序首页(AI健康助手小程序)
 * @param {*} params
 * @example
 * reLaunchMpIndexPage({
 *   active: '工具', // 用于小程序首页的tab切换
 * }) 
 */
export function reLaunchMpIndexPage(params) {
  wx.miniProgram.reLaunch({
    url: '/pages/index/index?' + param(params)
  });
}

/**
 * 调起小程序分享(AI健康助手小程序)
 * @param {*} params
 * @example
 * callWeChatShare({
 *   shareType: 'mentalHealthAssessmentResult', // 分享类型，inviteGift:邀请有礼分享,article:文章分享,mentalHealthAssessmentResult:心理健康测评结果分享
 *   title: '分享给您李四的心理健康测评结果报告，帮助孩子健康成长。',   // 分享标题   
 *   imageUrl: 'https://file.eyenurse.net/app/20230619/EYE_367908367463276134.jpg', // 分享图片
 *   path: '/pages/web/pub?url=' + encodeURIComponent('https://m.eyenurse.net/wxaward/demo/h5/questionnaire/result/XXXX') // 分享路径(或链接，可以是完整的https链接)
 * })
 */
export function callWeChatShare(params) {
  if (isWX()) {} else if (isApp()) {} else if (isMP()) {
    wx.miniProgram.navigateTo({
      url: '/pages/share/share?' + param(params)
    });
  }
}

//打开带头部 webview
export function openWebPage(url) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var base = process.env.BASE_URL;
  var baseUrl = base.slice(0, base.length - 1);
  var infos = {
    url: location.origin + baseUrl + url,
    title: title
  };
  if (isAndroid()) {
    if (jsCallNative.openWebPage) {
      jsCallNative.openWebPage(JSON.stringify(infos));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.openWebPage) {
      window.webkit.messageHandlers.openWebPage.postMessage(infos);
    }
  } else {
    openBaseUrl(url);
  }
}

//打开全屏webview
export function openFullWebPage(url) {
  var _url = location.origin + url;
  if (isAndroid()) {
    if (jsCallNative.openFullWebPage) {
      jsCallNative.openFullWebPage(_url);
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.openFullWebPage) {
      window.webkit.messageHandlers.openFullWebPage.postMessage(_url);
    }
  } else if (!isApp()) {
    location.href = _url;
  }
}
//打开用于筛查的webview
export function openWebPageScreenPage(url) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var base = process.env.BASE_URL;
  var baseUrl = base.slice(0, base.length - 1);
  var infos = {
    url: location.origin + baseUrl + url,
    title: title
  };
  if (isAndroid()) {
    if (jsCallNative.openWebPageScreenPage) {
      jsCallNative.openWebPageScreenPage(JSON.stringify(infos));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.openWebPageScreenPage) {
      window.webkit.messageHandlers.openWebPageScreenPage.postMessage(infos);
    }
  } else {
    openBaseUrl(url);
  }
}
//关闭当前app webview
export function closeNewPage() {
  if (isAndroid()) {
    if (jsCallNative.closeNewPage) {
      jsCallNative.closeNewPage();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.openNewPage) {
      window.webkit.messageHandlers.openNewPage.postMessage("close");
    }
  } else if (!isApp()) {
    history.go(-1);
  }
}

//调起打电话
export function callTel(tel) {
  if (isAndroid()) {
    if (jsCallNative.callTel) {
      jsCallNative.callTel(tel);
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.callTel) {
      window.webkit.messageHandlers.callTel.postMessage(tel);
    }
  } else {
    location.href = "tel:" + tel;
  }
}

//调起app客服
export function callKf() {
  if (isAndroid()) {
    if (jsCallNative.callKf) {
      jsCallNative.callKf();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.callKefu) {
      window.webkit.messageHandlers.callKefu.postMessage("callKefu");
    }
  }
}

//调起app商店客服
export function callShopKf(jimid) {
  if (isAndroid()) {
    if (jsCallNative.callShopKf) {
      jsCallNative.callShopKf(jimid);
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.callShopKf) {
      window.webkit.messageHandlers.callShopKf.postMessage(jimid);
    }
  }
}

//调起医院主页
export function callHospitalPage(hospital_id) {
  if (isAndroid()) {
    if (jsCallNative.callHospitalPage) {
      jsCallNative.callHospitalPage(hospital_id);
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.callHospitalPage) {
      window.webkit.messageHandlers.callHospitalPage.postMessage(hospital_id);
    }
  }
}

//显示webview右上角分享按钮
export function setAppShareInfo(shareInfo) {
  if (isAndroid()) {
    if (jsCallNative.cybAppShare) {
      jsCallNative.cybAppShare(JSON.stringify(shareInfo));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.cybAppShare) {
      window.webkit.messageHandlers.cybAppShare.postMessage(shareInfo);
    }
  }
}

//隐藏webview右上角分享按钮
export function hideAppShareBtn() {
  if (isAndroid()) {
    if (jsCallNative.hideAppShareBtn) {
      jsCallNative.hideAppShareBtn();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.hideAppShareBtn) {
      window.webkit.messageHandlers.hideAppShareBtn.postMessage('');
    }
  }
}

//商品详情调起 APP 带二维码分享图片
export function callQrcodeShare(shareInfo) {
  if (isAndroid()) {
    if (jsCallNative.callQrcodeShare) {
      jsCallNative.callQrcodeShare(JSON.stringify(shareInfo));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.callQrcodeShare) {
      window.webkit.messageHandlers.callQrcodeShare.postMessage(shareInfo);
    }
  }
}

//调起APP底部分享条
export function openShareBar(shareInfo) {
  if (isAndroid()) {
    if (jsCallNative.openShareBar) {
      jsCallNative.openShareBar(JSON.stringify(shareInfo));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.openShareBar) {
      window.webkit.messageHandlers.openShareBar.postMessage(shareInfo);
    }
  }
}

//调起APP微信支付 
export function callAppPay(params) {
  if (isAndroid()) {
    if (jsCallNative.appPay) {
      var jsonstr = JSON.stringify(params);
      jsCallNative.appPay(jsonstr);
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.appPay) {
      window.webkit.messageHandlers.appPay.postMessage(params);
    }
  }
}

//调起微信内页支付 
export function callWxPay(params, success, fail) {
  var jsApiCall = function jsApiCall(params) {
    window.WeixinJSBridge.invoke('getBrandWCPayRequest', params, function (res) {
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        success();
      } else {
        fail();
      }
    });
  };
  if (typeof window.WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', jsApiCall);
      document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
    }
  } else {
    jsApiCall(params);
  }
}

//设置webview标题
export function setWebPageTitle(title) {
  if (isAndroid()) {
    if (jsCallNative.setWebPageTitle) {
      jsCallNative.setWebPageTitle(title);
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.setWebPageTitle) {
      window.webkit.messageHandlers.setWebPageTitle.postMessage(title);
    }
  } else {
    document.title = title;
  }
}

//微信统一支付
export function callWeChatPay(params) {
  if (isWX()) {
    callWxPay(params, function () {}, function () {});
  } else if (isApp()) {
    callAppPay(params);
  }
}

//退出筛查app
export function logout() {
  if (isAndroid()) {
    if (jsCallNative.logout) {
      jsCallNative.logout();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.logout) {
      window.webkit.messageHandlers.logout.postMessage('');
    }
  }
}

// 筛查端文章状态改为已读
export function dynamicBottomReadStatusSet(data) {
  if (isAndroid()) {
    if (jsCallNative.dynamicBottomReadStatusSet) {
      jsCallNative.dynamicBottomReadStatusSet(JSON.stringify(data));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.dynamicBottomReadStatusSet) {
      window.webkit.messageHandlers.dynamicBottomReadStatusSet.postMessage(data);
    }
  }
}

//退出筛查app
export function showScan() {
  if (isAndroid()) {
    if (jsCallNative.showScan) {
      jsCallNative.showScan();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.showScan) {
      window.webkit.messageHandlers.showScan.postMessage('');
    }
  }
}
//智能筛查APP体检筛查展示右上角扫描按钮（展示）
export function visibleScanScreen() {
  if (isAndroid()) {
    if (jsCallNative.visibleScanScreen) {
      jsCallNative.visibleScanScreen();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.visibleScanScreen) {
      window.webkit.messageHandlers.visibleScanScreen.postMessage('');
    }
  }
}
//ceshi
// export function webToNativeOpenVisionCheck() {
//   if (isAndroid()) {
//     if (jsCallNative.webToNativeOpenVisionCheck) {
//       jsCallNative.webToNativeOpenVisionCheck()
//     }
//   } else if (isIOS()) {
//     if (window.webkit.messageHandlers.webToNativeOpenVisionCheck) {
//       window.webkit.messageHandlers.webToNativeOpenVisionCheck.postMessage('')
//     }
//   }
// }
//智能筛查APP体检筛查展示右上角扫描按钮（隐藏）
export function invisibleScanScreen() {
  if (isAndroid()) {
    if (jsCallNative.invisibleScanScreen) {
      jsCallNative.invisibleScanScreen();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.invisibleScanScreen) {
      window.webkit.messageHandlers.invisibleScanScreen.postMessage('');
    }
  }
}

//智能筛查APP问卷页面展示右上角扫描按钮（展示）
export function visibleScanQuestionnaire(url) {
  if (isAndroid()) {
    if (jsCallNative.visibleScanQuestionnaire) {
      jsCallNative.visibleScanQuestionnaire(JSON.stringify(url));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.visibleScanQuestionnaire) {
      window.webkit.messageHandlers.visibleScanQuestionnaire.postMessage(JSON.stringify(url));
    }
  }
}

//智能筛查APP问卷页面隐藏右上角扫描按钮（隐藏）
export function invisibleScanQuestionnaire() {
  if (isAndroid()) {
    if (jsCallNative.invisibleScanQuestionnaire) {
      jsCallNative.invisibleScanQuestionnaire();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.invisibleScanQuestionnaire) {
      window.webkit.messageHandlers.invisibleScanQuestionnaire.postMessage('');
    }
  }
}

//智能筛查APP问卷详情页面返回扫码页面
export function questionnaireGoBack() {
  if (isAndroid()) {
    if (jsCallNative.questionnaireGoBack) {
      jsCallNative.questionnaireGoBack();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.questionnaireGoBack) {
      window.webkit.messageHandlers.questionnaireGoBack.postMessage('');
    }
  }
}
//智能筛查APP 通知请给我当前选中的机器SN码
export function webToNativeToDo(params) {
  if (isAndroid()) {
    if (jsCallNative.webToNativeToDo) {
      jsCallNative.webToNativeToDo(JSON.stringify(params));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.webToNativeToDo) {
      window.webkit.messageHandlers.webToNativeToDo.postMessage(params);
    }
  }
}

// 获取原生筛查项配置
export function getNativeScreenSetting(type, cb) {
  var data = {
    type: type
  };
  window.nativeToWebScreenSetting = function (res) {
    cb(res);
  };
  if (isAndroid()) {
    if (jsCallNative.webToNativeCallScreenSetting) {
      jsCallNative.webToNativeCallScreenSetting(JSON.stringify(data));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.webToNativeCallScreenSetting) {
      window.webkit.messageHandlers.webToNativeCallScreenSetting.postMessage(data);
    }
  }
}

// web打开原生Ai检查页面
export function webToNativeOpenPhotoRecognition(aiType) {
  var data = {
    aiType: aiType
  };
  // 调起原生功能
  if (isAndroid()) {
    if (jsCallNative.webToNativeOpenPhotoRecognition) {
      jsCallNative.webToNativeOpenPhotoRecognition(JSON.stringify(data));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.webToNativeOpenPhotoRecognition) {
      window.webkit.messageHandlers.webToNativeOpenPhotoRecognition.postMessage(data);
    }
  }
}

// web打开原生视力表筛查页面
export function webToNativeOpenVisionCheck() {
  // 调起原生功能
  if (isAndroid()) {
    if (jsCallNative.webToNativeOpenVisionCheck) {
      jsCallNative.webToNativeOpenVisionCheck();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.webToNativeOpenVisionCheck) {
      window.webkit.messageHandlers.webToNativeOpenVisionCheck.postMessage('');
    }
  }
}

// 打开原生相机页面
export function callNativeCamera(cb) {
  window.listenNativeMessage = function (res) {
    cb(res);
  };
  if (isAndroid()) {
    if (jsCallNative.callNativeCamera) {
      jsCallNative.callNativeCamera();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.callNativeCamera) {
      window.webkit.messageHandlers.callNativeCamera.postMessage('');
    }
  }
}
// web打开原生IM单条消息详情页面
export function webToNativeMsgDetail(params) {
  // 调起原生功能
  if (isAndroid()) {
    if (jsCallNative.webToNativeMsgDetail) {
      jsCallNative.webToNativeMsgDetail(JSON.stringify(params));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.webToNativeMsgDetail) {
      window.webkit.messageHandlers.webToNativeMsgDetail.postMessage(params);
    }
  }
}
// web问原生是否开启了IM需要用的通知功能
export function webToNativeCheckNotificationPermission() {
  // 调起原生功能
  if (isAndroid()) {
    if (jsCallNative.webToNativeCheckNotificationPermission) {
      jsCallNative.webToNativeCheckNotificationPermission();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.webToNativeCheckNotificationPermission) {
      window.webkit.messageHandlers.webToNativeCheckNotificationPermission.postMessage('');
    }
  }
}
// web让原生开启通知功能
export function webToNativeOpenNotificationPermission() {
  // 调起原生功能
  if (isAndroid()) {
    if (jsCallNative.webToNativeOpenNotificationPermission) {
      jsCallNative.webToNativeOpenNotificationPermission();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.webToNativeOpenNotificationPermission) {
      window.webkit.messageHandlers.webToNativeOpenNotificationPermission.postMessage('');
    }
  }
}

// web让原生已读了就算打开横幅了
export function webToNativeReadedHelpInfo() {
  // 调起原生功能
  if (isAndroid()) {
    if (jsCallNative.webToNativeReadedHelpInfo) {
      jsCallNative.webToNativeReadedHelpInfo();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.webToNativeReadedHelpInfo) {
      window.webkit.messageHandlers.webToNativeReadedHelpInfo.postMessage('');
    }
  }
}
// web让原生已读了就算打开横幅了
export function webToNativeRefreshUnreadCount() {
  // 调起原生功能
  if (isAndroid()) {
    if (jsCallNative.webToNativeRefreshUnreadCount) {
      jsCallNative.webToNativeRefreshUnreadCount();
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.webToNativeRefreshUnreadCount) {
      window.webkit.messageHandlers.webToNativeRefreshUnreadCount.postMessage('');
    }
  }
}
// 通知智能筛查APP 去筛查页面
export function webToNativeToScreenPage(params) {
  if (isAndroid()) {
    if (jsCallNative.webToNativeToScreenPage) {
      jsCallNative.webToNativeToScreenPage(JSON.stringify(params));
    }
  } else if (isIOS()) {
    if (window.webkit.messageHandlers.webToNativeToScreenPage) {
      window.webkit.messageHandlers.webToNativeToScreenPage.postMessage(params);
    }
  }
}